import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MapPin, Star, ArrowRight } from 'lucide-react';
import ShareButton from '../ShareButton';

const TempleCard = ({ temple, index }) => {
  const categoryLabels = {
    char_dham: 'Char Dham',
    panch_kedar: 'Panch Kedar',
    shakti_peeth: 'Shakti Peeth',
    other: 'Sacred Temple'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="temple-card group relative bg-white rounded-2xl overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 card-hover cursor-pointer"
      data-testid={`temple-card-${temple.id}`}
    >
      <Link to={`/temples/${temple.id}`} className="block h-full">
        {/* Image */}
        <div className="relative h-56 overflow-hidden">
          <img
            src={temple.image_url}
            alt={temple.name}
            className="temple-card-image w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          
          {/* Category Badge */}
          <div className="absolute top-4 left-4">
            <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-[#4A6274] text-xs font-semibold rounded-full">
              {categoryLabels[temple.category] || 'Temple'}
            </span>
          </div>

          {/* Share - Keep as separate to allow clicking it without navigating */}
          <div className="absolute top-4 right-4 z-10" onClick={(e) => e.stopPropagation()}>
            <ShareButton
              url={`${window.location.origin}/temples/${temple.id}`}
              title={temple.name}
              text={`Book puja at ${temple.name} on Paramparik Pooja!`}
            />
          </div>

          {/* Location */}
          <div className="absolute bottom-4 left-4 flex items-center space-x-1 text-white/90">
            <MapPin className="w-4 h-4" />
            <span className="text-sm font-medium">{temple.location}</span>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <h3 className="font-heading text-xl font-bold text-[#1A202C] mb-2 group-hover:text-[#FF8C00] transition-colors">
            {temple.name}
          </h3>
          <p className="text-[#718096] text-sm mb-4 line-clamp-2">
            {temple.description}
          </p>

          {/* Pujas Available */}
          <div className="flex flex-wrap gap-2 mb-4">
            {temple.pujas_available?.slice(0, 2).map((puja, i) => (
              <span
                key={i}
                className="px-2 py-1 bg-[#FAFBFC] text-[#4A6274] text-xs rounded-lg"
              >
                {puja}
              </span>
            ))}
            {temple.pujas_available?.length > 2 && (
              <span className="px-2 py-1 bg-[#FF8C00]/10 text-[#FF8C00] text-xs rounded-lg">
                +{temple.pujas_available.length - 2} more
              </span>
            )}
          </div>

          {/* CTA */}
          <div
            className="flex items-center justify-between w-full pt-4 border-t border-gray-100 group/link"
          >
            <span className="text-[#FF8C00] font-semibold">Book Puja</span>
            <ArrowRight className="w-5 h-5 text-[#FF8C00] group-hover/link:translate-x-1 transition-transform" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default TempleCard;
